// PhonicsLt14.js
// 包装组件：Letter Teams L14
// 路由：/phonics/lt14
import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt14 } from './phonics/phonics_data_lt14';

function PhonicsLt14() {
  return <PhonicsLt letterData={letterDataLt14} />;
}

export default PhonicsLt14;
